import React from "react";
import {BeautifulCircleIcon} from './BeautifulCircleIcon';
import HelpBlockIcon from './HelpBlockIcon';


export class TgWidgetImplementationPage extends React.Component {

    state = {
        guideLink : 'https://telegra.ph/Kak-ustanovit-vidzhet-ClientSaver-na-sajt-07-22'
    }


    constructor(props) {
        super(props);
        
    }

   

   

    render() {
        return (
            <div>
                <div style={{marginTop: '1.8em'}}>
                <div className="widgetImplementationHelpBlock helpBlock"> <HelpBlockIcon /> Гайд: как установить виджет на сайт <a target="_blank" href={this.state.guideLink}>{this.state.guideLink}</a></div>
                </div>
                
                <div className='whiteBlock implementationBlock'>  

                <div className='whiteBlockTitle'>
                    <BeautifulCircleIcon/> 
                    <div className="whiteBlockTitleSpan">
                    Установка виджета на сайт
                    </div>
                </div>

                <div className="whiteBlockMiddle">
                    <div className='whiteBlockTextInputBlock_label' >
                        Вставьте данный код между тегами &lt;head&gt;&lt;/head&gt; на  сайте.
                    </div>
                    <textarea value={this.props.scriptsText }>  </textarea>    
                </div>
                <div className="whiteBlockButtonBlock"> 
                <a className='whiteBlockButton' onClick={() => {navigator.clipboard.writeText(this.props.scriptsText)}} href='#'>Копировать </a> </div>

            </div>    
            </div>
            
                        
                    
               
                     
        )
    }
}
